export const theme = {
  primary: 'hsl(347, 84%, 48%)',
  primaryLight: 'hsl(347, 73%, 71%);',
  white: 'hsl(0, 0%, 100%)',
  grey: 'hsl(0, 0%, 37%)',
  black: 'hsl(0, 0%, 0%)',
};
